import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1a9d2d23"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "details" }
const _hoisted_2 = { class: "has-label" }
const _hoisted_3 = { class: "has-label" }
const _hoisted_4 = { class: "has-label" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = {
  key: 0,
  class: "has-label"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Campaign:", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("ul", null, [
      _createElementVNode("li", _hoisted_2, [
        _createElementVNode("span", null, _toDisplayString(_ctx.$t("bookingType.title")) + ":", 1),
        _createElementVNode("span", null, _toDisplayString(_ctx.$t("bookingType."+_ctx.modeOfTravel)), 1)
      ]),
      _createElementVNode("li", _hoisted_3, [
        _createElementVNode("span", null, _toDisplayString(_ctx.$t("serviceType.title")) + ":", 1),
        _createElementVNode("span", null, _toDisplayString(_ctx.serviceType), 1)
      ]),
      _createElementVNode("li", _hoisted_4, [
        _createElementVNode("span", null, _toDisplayString(_ctx.$t("basket.passengers")) + ":", 1),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.passengers, (passenger, index) => {
          return (_openBlock(), _createElementBlock("span", { key: index }, [
            _createTextVNode(_toDisplayString(passenger.text) + " " + _toDisplayString(passenger.amount), 1),
            (index + 1 !== _ctx.passengers.length)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createTextVNode(", ")
                ], 64))
              : _createCommentVNode("", true)
          ]))
        }), 128)),
        (_ctx.passengers.length === 0)
          ? (_openBlock(), _createElementBlock("span", _hoisted_5, "-"))
          : _createCommentVNode("", true)
      ]),
      (_ctx.campaign)
        ? (_openBlock(), _createElementBlock("li", _hoisted_6, [
            _hoisted_7,
            _createElementVNode("span", null, _toDisplayString(_ctx.campaign), 1)
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}